<template>
    <div class="skel" id="root" :data-theme="theme">
        <cms-partial-data-provider name="menu" v-if="isMobile">
            <lateral-menu slot-scope="props" v-bind="props"/>
        </cms-partial-data-provider>

        <div class="skel--header">
            <cms-partial-data-provider name="menu">
                <main-header slot-scope="props" v-bind="props"/>
            </cms-partial-data-provider>
        </div>

        <main class="skel--main">
            <transition v-bind="routeTransitionAttrs"
                    @after-leave="afterRouteLeave"
                    @after-enter="afterRouteEnter">
                <router-view/>
            </transition>
        </main>
        <div class="skel--footer">
            <cms-partial-data-provider name="footer">
                <main-footer slot-scope="props" v-bind="props"/>
            </cms-partial-data-provider>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import vuexViewportMixin from 'framework/vuex/modules/viewport/mixin';
    import isMobileMixin from 'framework/mixins/is-mobile';
    import routeMixin from 'framework/mixins/route';
    import vuexScrollMixin from 'framework/vuex/modules/scroll/mixin';
    import routeTransitionMixin from 'framework/mixins/route-transition';
    import LateralMenu from 'framework/components/lateral-menu/lateral-menu';
    import CmsPartialDataProvider from 'framework/components/cms/cms-partial-data-provider/cms-partial-data-provider';
    import MainHeader from 'framework/components/main-header/main-header';
    import MainFooter from 'framework/components/main-footer/main-footer';

    export default {
        components: { LateralMenu, MainHeader, MainFooter, CmsPartialDataProvider },
        mixins: [
            vuexViewportMixin,
            vuexScrollMixin,
            routeMixin,
            routeTransitionMixin,
            isMobileMixin,
        ],
        computed: {
            ...mapState('page', ['theme']),
        },
    };
</script>
